import store from '@/store'

/** Если данные фильтров не найдены  - пытаемся запросить данные на сервере */

export default async (to, from, next) => {
  //console.log("middleware-check-operators")
  if (!store.getters['filters/check_filters']) {
    try {
      await store.dispatch('users/fetchUsers')
      await store.dispatch('filters/fetchOperatorsGroups')
      await store.dispatch('filters/fetchDistricts')
    } catch (e) {
      //
    }
  }

  next()
}
